<template>
  <div class="progressor" :class="type" :style="styler">
    <div class="indicator" v-if="type==='segment'" :style="`width:${this.percent}`"></div>
    <div class="indicator" v-if="type==='segment' && status==='INDETERMINATE'"
         :style="`position:absolute;top:0;background:#EEEEEE;width:${Math.max(0,this.percent.replace('%','')-12)}%`"/>
    <slot>&nbsp;</slot>
  </div>
</template>
<script>
export default {
  name: 'Progressor',
  props: {
    'percent': {
      type: String
    },
    'type': {
      type: String,
      default: 'pie'
    },
    'status': {
      type: String,
      default: 'DETERMINATE'
    }
  },
  computed: {
    styler: function () {
      return this.type === 'pie'
          ? `background: radial-gradient(closest-side, white 77%, transparent 80%, transparent 100%), conic-gradient(from ${this.status === 'INDETERMINATE' ? 360 / 100 * (this.percent.replace('%', '') * 1) : '0'}deg, var(--color-agency-progressor) ${this.status === 'DETERMINATE' ? this.percent : '26%'}, #BDB9B740 0)` : '';
    }
  }
}
</script>
<style lang="scss">
.progressor {
  position: relative;

  >* {
    //height: 100%;
  }

  &.pie {
    text-align: center;
    aspect-ratio: 1/1;
    border-radius: 50%;
    //padding: .75em;
    max-width: 120px;
    max-height: 120px;
    margin: 0 auto;
    display: flex;
    align-items: center;

    &>div {
      //height: 100%;
    }
  }

  &.segment {
    --segment-height: 4px;
    background: #EEEEEE;
    height: var(--segment-height);
    line-height: var(--segment-height);
    overflow: hidden;

    > .indicator {
      content: '.';
      text-indent: -100px;
      display: block;
      height: var(--segment-height);
      line-height: var(--segment-height);
      border-radius: var(--segment-height);
      background: var(--color-agency-progressor);
      width: v-bind(percent);
    }
  }
}
</style>